import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { submitEnclosureFiles, submitEnclouser } from "../../auth/services/privateapicalling";


interface EnclosureProps {
  onNext: (data: any) => void;
  onPrev: () => void;
  isEnclouserFilled: boolean;
  existData:any;
  applicationId:string | null;
  fetchApplicationExistenceCheck: () => Promise<void>;
}

const Enclosures: React.FC<EnclosureProps> = ({ onNext, onPrev ,fetchApplicationExistenceCheck,applicationId, isEnclouserFilled,existData}) => {
//.log('existData enc',existData) // Moved or removed to avoid error

  const [files, setFiles] = useState<{ [key: string]: File | null }>({});
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [uploadStatus, setUploadStatus] = useState<{ [key: string]: boolean }>({});

  const language = useSelector((state: any) => state.auth.language);
  const formLanguage = useSelector((state: any) => state.auth.formLanguage)
  
  const token = useSelector((state: any) => state.auth.token);
    const userdetails = useSelector((state: any) => state.auth.userDetails);
    const applicationIdRedux = useSelector((state:any)=>state.auth.applicationId);
    const appId = userdetails.applicationId ? userdetails.applicationId : applicationIdRedux;
    const [isAllFieldsUploaded, setIsAllFieldsUploaded] = useState<boolean>(false);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [errors, setErrors] = useState({});
    const [selectedLang, setSelectedLang] = useState<string>("");
    

    const entityType = existData?.entityType;

  const  allFields = [
    {type:"solvencyCertificate",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Solvency Certificate"},
    {type:"bankGuarntee",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Bank Guarantee"},
    {type:"bankBalanceCertificate",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Bank Balance Certificate"},
    {type:"itReturns_1",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"IT Returns 1"},
    {type:"itReturns_2",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"IT Returns 2"},
    {type:"itReturns_3",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"IT Returns 3"},
    {type:"panCard",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Pan Card "},
    {type:"electionCard",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Election Card"},
    // {type:"chalanPayementLiceneseFee",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Challan Payment License Fee"},                                                                                                                                                                                                                                                                                                                
    {type:"proofOfBusinessPalace",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Proof of Business Place"},
    {type:"partnerShipDeed",allowRole:["partnerFirm"],label:"Partnership Deed"},
    {type:"companyArticleAssociation",allowRole:["Firm","Company","CoSciety","Llp"],label:"Company Article Association"},
    {type:"coOpSocietyByLaws",allowRole:["CoSciety"],label:"Co-operative Society Bye Laws"},
    {type:"affidavit",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Affidavit"},
    // {type:"enclousreDeclaration",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Enclosure Declaration"},
    {type:"declarations",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Declarations"},
    {type:"traderSignature",allowRole:["Ind","Firm","Company","CoSciety","Fpo","govEnt","Ngo","partnerFirm","Llp","Trust","Jv"],label:"Trader Signature"},
  ];

  const fields =  allFields.filter(data=>data.allowRole.includes(existData?.entityType))

  const today = new Date();
const currentYear = today.getFullYear();
const july31 = new Date(currentYear, 6, 31); // July is month 6 (0-indexed)
const endYear = today <= july31 ? currentYear - 1 : currentYear;

const fiscalYears = [];
for (let i = 0; i < 3; i++) {
  const fyEnd = endYear - i;
  const fyStart = fyEnd - 1;
  fiscalYears.push(`FY ${fyStart}-${fyEnd}`);
}

const updatedFields = fields.map((field) => {
  if (field.type === "itReturns_1") {
    return { ...field, label: `IT Returns (${fiscalYears[0]})` };
  } else if (field.type === "itReturns_2") {
    return { ...field, label: `IT Returns (${fiscalYears[1]})` };
  } else if (field.type === "itReturns_3") {
    return { ...field, label: `IT Returns (${fiscalYears[2]})` };
  }
  return field;
});

  const validationSchema = Yup.object().shape({
    uploadedFiles: Yup.object().shape(
      fields.reduce((acc, field) => {
        acc[field.type] = Yup.mixed()
          .nullable()
          .notRequired()
          // custom test for required+format+size when this is the currentField
          .test({
            name: "currentFileValidation",
            message: `${field.label} is required and must be a valid PDF/JPG under 3MB.`,
            test: function (value) {
              const { currentField } = this.options.context as { currentField?: string };
              // if we're not validating this field right now, skip all tests:
              if (currentField !== field.type) {
                return true;
              }
  
              // Now enforce required:
              if (!value || !(value instanceof File)) {
                return this.createError({ message: `${field.label} is required` });
              }
  
              // enforce format:
              const allowed = ["application/pdf", "image/jpeg", "image/jpg"];
              if (!allowed.includes(value.type)) {
                return this.createError({ message: "Only PDF, JPG, and JPEG files are allowed." });
              }
  
              // enforce min size:
              if (value.size < 40 * 1024) {
                return this.createError({ message: "File size must be at least 40KB." });
              }
  
              // enforce max size:
              if (value.size > 3 * 1024 * 1024) {
                return this.createError({ message: "File size must be less than 3MB." });
              }
  
              // all good:
              return true;
            },
          });
  
        return acc;
      }, {} as Record<string, Yup.MixedSchema<any, any>>)
    ),
  });

  const validationSchemaforsubmit = Yup.object().shape({
    uploadedFiles: Yup.object().shape(
      fields.reduce((acc, field) => {
        acc[field.type] = Yup.mixed()
          .test("required", `${field.label} is required`, (value) => value && value instanceof File)
          .required(`${field.label} is required`);
          //.log('acc',acc)
        return acc;
      }, {})

    ),
   
  });


  const validateAndSubmit = async (fieldName: string) => {
    const file = files[fieldName];
    if (!file) {
      setErrors((prev) => ({ ...prev, [fieldName]: "This file is required" }));
      return false;
    }
  
    const payload = { uploadedFiles: { [fieldName]: file } };
   
  
    try {
      await validationSchema.validate(payload, {
        abortEarly: false,
        context: { currentField: fieldName },
      });
  
      setErrors((prev) => {
        const next = { ...prev };
        delete next[fieldName];
        return next;
      });
      return true;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const validationErrors: Record<string, string> = {};
        err.inner.forEach((e) => {
          const parts = e.path?.split(".");
          const key = parts?.[1];
          if (key === fieldName) {
            validationErrors[key] = e.message;
          }
        });
        setErrors((prev) => ({ ...prev, ...validationErrors }));
        return false;
      }
  
      return false;
    }
  };
  

  const validate = async () => {
    try {
      //.log('files', files); // Log the actual files state
      const validFiles = Object.keys(files).reduce((acc, key) => {
        if (files[key]) {
          acc[key] = files[key];
        }
        return acc;
      }, {});

      //.log('validFiles', validFiles); // Log only valid files
      await validationSchemaforsubmit.validate({ uploadedFiles: validFiles }, { abortEarly: false });
      //.log("All files are valid. Submitting...", validFiles);
      setErrors({});
      return true; // Indicate successful validation
    } catch (err) {
      const validationErrors: { [key: string]: string } = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path) {
            validationErrors[error.path.split(".")[1]] = error.message;
          }
        });
      }
      setErrors(validationErrors);
      //.error("Validation errors:", validationErrors);
      return false; // Indicate validation failure
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
    const file = e.target.files?.[0] || null;
   
    setFiles((prev) => ({ ...prev, [fieldName]: file }));

      const existingDoc = existData && existData.docs?.find((doc: any) => doc.documentName === fieldName);
                      
                          handleUpload(fieldName,file, existingDoc?.id)
  };

    const toastCooldown = useRef(false);
  
    const showErrorToast = (message: string) => {
      if (toastCooldown.current) return; // Skip if still in cooldown
    
      toast.error(message);
      toastCooldown.current = true;
    
      // Reset cooldown after 3 seconds
      setTimeout(() => {
        toastCooldown.current = false;
      }, 3000);
    };


  const handleUpload = async (fieldName: string, fileData: any, docId?: string | null) => {
    if (!fileData) return;
  
  
  
    const formData = new FormData();
    formData.append("file", fileData as Blob);
    formData.append("documentName", fieldName);
    formData.append("applicationId", applicationId);
  
    

    try {
      setUploading(true);
      const res = await submitEnclosureFiles(formData, token, docId);
      fetchApplicationExistenceCheck()
      setUploadedFiles((prev) => ({ ...prev, [fieldName]: true }));
     
      if(res.success==true)
        {
          toast.success(res?.message,{position: "top-right", autoClose: 3000,});
        }
        else{
          toast.error(res?.message,{position: "top-right", autoClose: 3000,});
        }
    } catch (error) {
      // alert("File upload failed");
      toast.error("File upload failed", {position: "top-right", autoClose: 3000,});
      
    } finally {
      setUploading(false);}
  };

  const handleDownload = (fileNames: string[]) => {
    fileNames.forEach((fileName) => {
      const fileUrl = `/${fileName}`; // Ensure correct file path
  
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const areAllFilesUploaded = () => {
    return updatedFields.every((field) => uploadedFiles[field.type]);
  };

  const handleSubmit = async () => {
  
    // const isValid = validateAndSubmit()
    // //.log('is valid',isValid)
    const isValid = await validate()
    //.log('is valid',isValid)
    if (!isValid) {
      //.log("Validation failed. Fix errors before submitting.");
      return;
    }

    if (!areAllFilesUploaded()) {
      showErrorToast("Please upload all required documents before submitting.");
      return;
    }

    // if ( isAllFieldsUploaded) {
      const body = {
        applicationId:applicationId,
        isEnclouserFilled:true
      }
      setLoading(true);
      const submitEnclouserStatus = await submitEnclouser(body , token)
      // //.log('submitEnclouserStatus',submitEnclouserStatus)
      setLoading(false);

      onNext(files);
    // }
  };

  useEffect(() => {
    if (existData?.docs?.length && updatedFields?.length) {
      const uploadedMap: Record<string, boolean> = {};
  
      updatedFields.forEach((field) => {
        const isUploaded = existData.docs.some(
          (doc) => doc.documentName === field.type
        );
        if (isUploaded) {
          uploadedMap[field.type] = true;
        }
      });
  
      setUploadedFiles(uploadedMap);
    }
  }, []);


 //.log("existData.entityType",existData.entityType)
  return (
    <div className="">
      <div className="">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">{language.enclosures_heading}</h5>
                <p className="text-danger mb-1">{language.file_type}</p>
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    {updatedFields.map((field, index) => (
                      
                      <>
                      {/* field.allowRole.includes(existData.entityType ) &&  */}
                   {  
                      <div key={field.type} className="col-md-6 mb-3">
                       
                          {/* <span className="text-danger">*</span> */}
                          <label className="col-form-label">
                              {/* {index + 1}. {formLanguage[field.type]} ({language[field.type]}) */}
                              {index + 1}. {
                                  ["itReturns_1", "itReturns_2", "itReturns_3"].includes(field.type)
                                    ? `${formLanguage[field.type]} (${field.label})`
                                    : `${formLanguage[field.type]} (${language[field.type]})`
                                }
                              <span className="text-danger">*</span>
                              {/* {field.type === "enclousreDeclaration" && (
                                <div className="d-flex align-items-center">
                            
                                  <select
                                    className="form-select w-auto me-2"
                                    onChange={(e) =>
                                      setSelectedLang(e.target.value)
                                    } // Update state only
                                  >
                                    <option value="">
                                      Select Language For Download
                                    </option>
                            
                                    <option value="gujarati">Gujarati</option>
                                  </select>
 
                             
                                  <button
                                    type="button"
                                    className="btn btn-link text-danger"
                                    onClick={() => {
                                      if (!selectedLang) {
                                        alert("Please select a language");
                                        return;
                                      }
                                      handleDownload(
                                        selectedLang === "english"
                                          ? ["enclosure_declaration 1.pdf"]
                                          : [
                                              "enclosure_declaration1ingujarati.pdf",
                                            ]
                                      );
                                    }}
                                  >
                                   <span className="text-danger">Download</span> <i
                                      className="fa fa-file-pdf"
                                      data-bs-toggle="tooltip"
                                      title="Download"
                                    />
                                  </button>
                                </div>
                              )} */}
                              {field.type === "declarations" && (
                                <div className="d-flex align-items-center">
                                 
                                  {/* <select
                                    className="form-select w-auto me-2"
                                    value={selectedLang}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLSelectElement>
                                    ) => setSelectedLang(e.target.value)}
                                  >
                                    <option value="">
                                      Select Language For Download
                                    </option>
                            
                                    <option value="gujarati">Gujarati</option>
                                  </select> */}
 
                                  <button
                                    type="button"
                                    className="btn btn-link text-danger"
                                    onClick={() => {
                                      // if (!selectedLang) {
                                      //   alert("Please select a language"); // Alert if no language is selected
                                      //   return;
                                      // }
                                      handleDownload(
                                         [
                                              "EnclosureDeclarationCommon.pdf",
                                            ]
                                      );
                                    }}
                                  >
                                      <span className="text-danger">Declaration</span><i
                                      className="fa fa-file-pdf"
                                      data-bs-toggle="tooltip"
                                      title="Download Declaration"
                                    />
                                  </button>
                                </div>
                              )}
                            </label>
 
                        <div className="d-flex flex-column w-100">
                          <input
                          className={`form-control` }
                          type="file"
                          accept=".pdf, .jpeg, .jpg"
                          onChange={(e) => handleFileChange(e, field.type)}
                          />
                            {existData && existData.docs?.find((doc: any) => doc.documentName === field.type)?.fileName && (
                            <>
                            <p>{existData.docs.find((doc: any) => doc.documentName === field.type)?.fileName}</p>
                            {files[field.type] === undefined && (() => {
                              setFiles((prev) => ({
                                ...prev,
                                [field.type]: new File([], existData.docs.find((doc: any) => doc.documentName === field.type)?.fileName || ""),
                              }));
                              return null;
                            })()}
                            </>
                            
                            )}
                          
                          
                        </div>
                        {errors[field.type] && (
                          <p className="text-danger">{errors[field.type]}</p>
                        )}
                          {/* {files[field.type] && (
                          <button
                          className="btn btn-success ms-2"
                          type="button"
                          onClick={async () => {
                          const existingDoc = existData && existData.docs?.find((doc: any) => doc.documentName === field.type);
                          //.log('exxxxx',existingDoc)
                          await handleUpload(field.type, existingDoc?.id);
                          // fetchApplicationExistenceCheck(); // Trigger re-fetch to update existing fields
                          }}
                          // disabled={uploading[field]}
                          >
                          <i className="fa fa-upload" data-bs-toggle="tooltip" title="Upload" />
                          </button>
                          )} */}
                        </div>}
                      </>
                    ))}
                  </div>
                  <div className="d-flex justify-content-start mt-3">
                    <button type="button" className="btn btn-secondary" onClick={onPrev}>
                      {language.previous}
                    </button>
                   </div>
                   <div className="d-flex justify-content-end mt-3">
                    <button type="button" className="btn btn-primary" onClick={handleSubmit}  
                    // disabled={!isAllFieldsUploaded}  
                     >
                      {language.next}
                    </button>
                    {/* <ToastContainer position="top-center" autoClose={3000} /> */}
                    
                  </div>
                  {/* {!isAllFieldsUploaded && <p className="text-danger mt-2">All files must be uploaded before proceeding.</p>} */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {(uploading || loading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
          style={{ zIndex: 9999 }}
        >
          <div className="d-flex align-items-center px-4 py-3 bg-white rounded shadow">
            <div
              className="spinner-border text-primary me-3"
              role="status"
            />
            <span className="fw-semibold text-dark">
              {uploading ? "Uploading..." : "Submitting..."}
            </span>
          </div>
        </div>
      )}
      
    </div>
  );
};

export default Enclosures;
